import { Controller } from 'stimulus';

import dataLayer from '../tracking/dataLayer';
import delegatedEventListener from '../helpers/delegatedEventListener';
import throttle from '../helpers/throttle';

const SCROLL_THRESHOLDS = [10, 25, 50, 90, 100];

class Tracking extends Controller {
  // eslint-disable-next-line class-methods-use-this
  connect() {
    this.resetScrollThresholds();
    this.breakpointTrackers = [];

    this.windowHeight = window.innerHeight;
    this.documentHeight = document.body.clientHeight;
    this.throttledWindowScroll = throttle(this.onScroll.bind(this), 200);

    Tracking.trackLinks();
    this.trackEngagementTime();

    window.addEventListener('resize', this.onWindowResize.bind(this));
    window.addEventListener('scroll', this.throttledWindowScroll);
  }

  disconnect() {
    window.removeEventListener('resize', this.onWindowResize.bind(this));
    window.removeEventListener('scroll', this.throttledWindowScroll);
  }

  resetScrollThresholds() {
    this.scrollThresholds = SCROLL_THRESHOLDS.slice();
  }

  onWindowResize() {
    this.windowHeight = window.innerHeight;
    this.documentHeight = document.body.clientHeight;
  }

  onScroll() {
    const end = this.documentHeight - this.windowHeight;
    const currentThreshold = (window.scrollY / end) * 100;

    this.scrollThresholds.forEach((threshold, index) => {
      if (currentThreshold >= threshold) {
        dataLayer.event('Scroll depth', threshold, window.location.pathname);

        this.scrollThresholds.splice(index, 1);
      }
    });
  }

  trackEngagementTime() {
    const breakpoints = [5, 15, 30, 60];

    this.breakpointTrackers.forEach((tracker) => {
      clearTimeout(tracker);
    });

    this.breakpointTrackers = [];

    breakpoints.forEach((breakpoint) => {
      const timeout = setTimeout(() => {
        dataLayer.event('Engaged Time', window.location.href, breakpoint, breakpoint);
      }, breakpoint * 1000);

      this.breakpointTrackers.push(timeout);
    });
  }

  static trackLinks() {
    delegatedEventListener('click', 'a', document, ({ target }) => {
      if (target.matches('a[href^="tel:"]')) {
        dataLayer.event('Phone', 'click', target.href);
        return;
      }

      if (target.matches('a[href^="mailto:"]')) {
        dataLayer.event('Mail', 'click', target.href);
        return;
      }

      if (
        typeof target !== 'undefined'
        && typeof target.href !== 'undefined'
        && target.href.indexOf(window.location.host) <= 0
        && target.href.match(/^http/i)
      ) {
        dataLayer.event('Outbound', 'click', target.href);
      }
    });
  }
}

Tracking.targets = [
  //
];

export default Tracking;
